var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import { Response } from 'packages/form/entities/legacy/Response';
import { Talent } from 'packages/talent/entities/Talent';
import { Tag } from 'packages/company/entities/Tag';
import Attachment from 'packages/jobs/entities/Attachment';
import { PipelineHelper } from 'packages/utilities/PipelineHelper';
import { PipelineStage } from 'packages/v3/pipeline/PipelineStage';
var Application = /** @class */ (function (_super) {
    __extends(Application, _super);
    function Application() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.companyId = null;
        _this.jobId = null;
        _this.jobTitle = null;
        _this.jobCityName = null;
        _this.title = null;
        _this.description = null;
        _this.source = null;
        _this.score = 0;
        _this.status = 0;
        _this.talent = new Talent();
        _this.attachments = [];
        _this.tags = [];
        _this.formResponse = null;
        _this.formResponseUuid = null;
        _this.createdAt = null;
        _this.pipelineStageId = null;
        return _this;
    }
    Object.defineProperty(Application.prototype, "name", {
        get: function () {
            return this.jobTitle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "statusTranslationKey", {
        get: function () {
            return (new PipelineHelper()).getTranslationKeyForStatusId(this.status);
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c;
    __decorate([
        Type(Talent, 'talent'),
        __metadata("design:type", typeof (_a = typeof Talent !== "undefined" && Talent) === "function" ? _a : Object)
    ], Application.prototype, "talent", void 0);
    __decorate([
        Type(Attachment, 'attachments'),
        __metadata("design:type", Array)
    ], Application.prototype, "attachments", void 0);
    __decorate([
        Type(Tag, 'tags'),
        __metadata("design:type", Array)
    ], Application.prototype, "tags", void 0);
    __decorate([
        Type(Response),
        __metadata("design:type", typeof (_b = typeof Response !== "undefined" && Response) === "function" ? _b : Object)
    ], Application.prototype, "formResponse", void 0);
    __decorate([
        Type(PipelineStage),
        __metadata("design:type", typeof (_c = typeof PipelineStage !== "undefined" && PipelineStage) === "function" ? _c : Object)
    ], Application.prototype, "pipelineStage", void 0);
    return Application;
}(Entity));
export default Application;
